import { styled } from '@mui/material'
import { Box } from '@mui/material'

export const ContainerBridgeStyled = styled(Box)(() => ({
  display: 'flex',
  gap: '24px',
}))
